import Rete, { Socket} from "rete";
import VueStockChartControl from "./StockChartControl.vue";

export class StockChartControl extends Rete.Control {
  constructor(emitter, key) {
    super(key);
    this.render = "vue";
    this.component = VueStockChartControl;
    this.props = { emitter, ikey: key };
  }

  setValue(val) {
    let update = true;
    if(val !== null &&  this.vueContext.value !== null){
      let lastNew = val[0].data.length - 1 
      let lastOld =this.vueContext.value[0].data.length - 1
      let dateSame = val[0].data[0].x == this.vueContext.value[0].data[0].x &&
      val[0].data[lastNew].x == this.vueContext.value[0].data[lastOld].x;

      let openSame = val[0].data[0].y[0] == this.vueContext.value[0].data[0].y[0] &&
      val[0].data[lastNew].y[0] == this.vueContext.value[0].data[lastOld].y[0];

      if(dateSame && openSame){
        update = false;
      }
    } 
   if(update){
    this.clearAnnotation();
    this.vueContext.value = val;
   } 
  }

  addAnnotation(stocks){
    this.vueContext.addAnnotation(stocks);
  }
  hasAnnotation(stocks){
    return this.vueContext.hasAnnotation(stocks);
  }

  addYAnnotation(key,numberIn){
    this.vueContext.addYAnnotation(key,numberIn);
  }
  hasYAnnotation(key,numberIn){
    return this.vueContext.hasYAnnotation(key,numberIn);
  }
  
  clearAnnotation(){
    this.vueContext.clearAnnotation();
  }
}

// const StockDataSocket = new Socket("StockData");
// StockDataSocket.combineWith(AnyTypeSocket);
// export { StockDataSocket };

